import { YStack } from 'tamagui';

import { GuideBlurb } from '../../components/guide/GuideBlurb';
import { BodySmallRegular, H6Regular } from '../../components/text/Typography';
import { CONTENT_MAX_WIDTH } from '../../constants';

export const GuideBlurbs = () => {
    return (
        <>
            <YStack gap={24} maxWidth={CONTENT_MAX_WIDTH}>
                <H6Regular>Default</H6Regular>
                <GuideBlurb
                    guideImageSrc="https://d1pwidzl9kib4u.cloudfront.net/guides_headshots/20230726_FF_guide_headshot_colin_FEE9D1.jpg"
                    heading="Your Money Map is here!"
                    message="As part of your Money Map setup, we'll guide you through opening necessary Fruitful accounts and turning on your Income Split."
                />
            </YStack>

            <YStack gap={24} maxWidth={CONTENT_MAX_WIDTH}>
                <H6Regular>With Custom Content</H6Regular>
                <GuideBlurb
                    guideImageSrc="https://d1pwidzl9kib4u.cloudfront.net/guides_headshots/20230726_FF_guide_headshot_colin_FEE9D1.jpg"
                    heading="Custom styled message"
                    message={
                        <YStack gap={8}>
                            <BodySmallRegular color="$gray1000">
                                You can pass custom React components as the
                                message prop for more complex layouts.
                            </BodySmallRegular>
                        </YStack>
                    }
                />
            </YStack>
        </>
    );
};
